// CDN base URLs.
//
// Asset paths below still point at the create-friend ("createsexfriend") CDN
// folder so the UI has something to render right now. They are placeholders
// — replace with the trans-specific CDN folder once real assets are produced.
export const CDN_BASE_URL = 'https://cdnsm.swipey.ai/prelander/createsexfriend';
export const CDN_URL = 'https://cdnsm.swipey.ai';

// Five quiz steps + a `summary` marker that triggers navigation to /summary.
export const QUIZ_STEPS = [
  'step1',
  'step2',
  'step3',
  'step4',
  'step5',
  'summary',
];

export const STORAGE_KEYS = {
  AI_TRANS_SELECTIONS: 'aiTransSelections',
  TRACKING_PARAMS: 'trackingParams',
};

// Step 1 — Ethnicity (Asian / Caucasian)
const ethnicity = [
  {
    value: 'Asian',
    text: 'ethnicity.asian',
    image: `${CDN_BASE_URL}/Realistic/step1-image2.png`,
    video: `${CDN_BASE_URL}/attribute_videos/ethnicity/Asian.mp4`,
    extendVideo: `${CDN_BASE_URL}/attribute_videos/ethnicity/extend/3_Asian.mp4`,
    alt: 'Asian trans',
  },
  {
    value: 'Caucasian',
    text: 'ethnicity.caucasian',
    image: `${CDN_BASE_URL}/Realistic/step1-image1.png`,
    video: `${CDN_BASE_URL}/attribute_videos/ethnicity/White.mp4`,
    extendVideo: `${CDN_BASE_URL}/attribute_videos/ethnicity/extend/3_White.mp4`,
    alt: 'Caucasian trans',
  },
];

// Step 2 — Personality (8 traits)
const personality = [
  {
    value: 'Sporty',
    text: 'personalityTraits.sporty',
    image: `${CDN_BASE_URL}/Realistic/step2-body1.png`,
    alt: 'Sporty',
  },
  {
    value: 'Goth',
    text: 'personalityTraits.goth',
    image: `${CDN_BASE_URL}/Porn/gothgirl.webp`,
    alt: 'Goth',
  },
  {
    value: 'Artist',
    text: 'personalityTraits.artist',
    image: `${CDN_BASE_URL}/Realistic/step2-body3.png`,
    alt: 'Artist',
  },
  {
    value: 'Student',
    text: 'personalityTraits.student',
    image: `${CDN_BASE_URL}/Porn/collegestudent.webp`,
    alt: 'Student',
  },
  {
    value: 'Activist',
    text: 'personalityTraits.activist',
    image: `${CDN_BASE_URL}/Realistic/step2-body4.png`,
    alt: 'Activist',
  },
  {
    value: 'Ladyboy',
    text: 'personalityTraits.ladyboy',
    image: `${CDN_BASE_URL}/Realistic/step2-body2.png`,
    alt: 'Ladyboy',
  },
  {
    value: 'Soldier',
    text: 'personalityTraits.soldier',
    image: `${CDN_BASE_URL}/Porn/dominatrix.webp`,
    alt: 'Soldier',
  },
  {
    value: 'Actress',
    text: 'personalityTraits.actress',
    image: `${CDN_BASE_URL}/Porn/pornstar.webp`,
    alt: 'Actress',
  },
];

// Step 3 — Body Type
const bodyType = [
  {
    value: 'Slim',
    text: 'bodyType.slim',
    image: `${CDN_BASE_URL}/Realistic/step2-body1.png`,
    video: `${CDN_BASE_URL}/attribute_videos/body/Petite_body.mp4`,
    alt: 'Slim',
  },
  {
    value: 'Athletic',
    text: 'bodyType.athletic',
    image: `${CDN_BASE_URL}/Realistic/step2-body2.png`,
    video: `${CDN_BASE_URL}/attribute_videos/body/Toned_body.mp4`,
    alt: 'Athletic',
  },
];

// Step 4 — Hairstyle (6) + Eye Color (2)
const hairStyle = [
  {
    value: 'Straight',
    text: 'hairStyle.straight',
    image: `${CDN_BASE_URL}/Realistic/step3-hairstyle1.png`,
    alt: 'Straight',
  },
  {
    value: 'Bangs',
    text: 'hairStyle.bangs',
    image: `${CDN_BASE_URL}/Realistic/step3-hairstyle2.png`,
    alt: 'Bangs',
  },
  {
    value: 'Braids',
    text: 'hairStyle.braids',
    image: `${CDN_BASE_URL}/Realistic/step3-hairstyle3.png`,
    alt: 'Braids',
  },
  {
    value: 'Bun',
    text: 'hairStyle.bun',
    image: `${CDN_BASE_URL}/Realistic/step3-hairstyle4.png`,
    alt: 'Bun',
  },
  {
    value: 'Curly',
    text: 'hairStyle.curly',
    image: `${CDN_BASE_URL}/Realistic/step3-hairstyle5.png`,
    alt: 'Curly',
  },
  {
    value: 'Ponytail',
    text: 'hairStyle.ponytail',
    image: `${CDN_BASE_URL}/Realistic/step3-hairstyle6.png`,
    alt: 'Ponytail',
  },
];

const eyeColor = [
  {
    value: 'Blue',
    text: 'eyeColor.blue',
    image: `${CDN_BASE_URL}/Realistic/step3-eye1.png`,
    alt: 'Blue eyes',
  },
  {
    value: 'Brown',
    text: 'eyeColor.brown',
    image: `${CDN_BASE_URL}/Realistic/step3-eye2.png`,
    alt: 'Brown eyes',
  },
];

// Step 5 — Voice (3) + Relationship (3) + Age (slider)
const voice = [
  {
    value: 'Teen',
    text: 'voice.teen',
    audio: `${CDN_BASE_URL}/sounds/voice2.mp3`,
  },
  {
    value: 'Soft',
    text: 'voice.soft',
    audio: `${CDN_BASE_URL}/sounds/voice3.mp3`,
  },
  {
    value: 'Dominant',
    text: 'voice.dominant',
    audio: `${CDN_BASE_URL}/sounds/voice4.mp3`,
  },
];

const relationship = [
  {
    value: 'stepSis',
    text: 'relationship.stepSis',
  },
  {
    value: 'stepMom',
    text: 'relationship.stepMom',
  },
  {
    value: 'girlfriend',
    text: 'relationship.girlfriend',
  },
];

export const QUIZ_OPTIONS_DATA = {
  ethnicity,
  personality,
  bodyType,
  hairStyle,
  eyeColor,
  voice,
  relationship,
};

export const getQuizOptionsData = (step) => QUIZ_OPTIONS_DATA[step] || [];

export const RELATIONSHIP_TITLES = {
  stepSis: 'relationship.stepSis',
  stepMom: 'relationship.stepMom',
  girlfriend: 'relationship.girlfriend',
};

export const PERSONALITY_TITLES = RELATIONSHIP_TITLES;

// Asian and Caucasian each map to one of the two existing trans characters on
// the platform. The signup-redirect URL is built from this mapping.
export const CHARACTER_BY_ETHNICITY = {
  Asian: {
    slug: 'sora_tanaka',
    displayName: 'Sora Tanaka',
  },
  Caucasian: {
    slug: 'isabelle_davies',
    displayName: 'Isabelle Davies',
  },
};
